import { apiGet } from '../api'

export const get_draft_register = id => {
  return apiGet({
    endpoint: `attendance/get_draft_register?program_id=${id}`
  })
}
